/* tslint:disable */
/* eslint-disable */
/* @relayHash fc87cae2b2a9ce2b02fb9edf442b8e4a */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespRootQueryVariables = {
    userId?: string | null;
    fetchUser: boolean;
    uriRef?: string | null;
    first: number;
    page: number;
    localeOrigin?: string | null;
    isTrade: boolean;
    showSeller: boolean;
    followSearchPages?: Array<string | null> | null;
    followSearchTypes?: Array<types | null> | null;
    contentModuleId?: string | null;
    eligibleAbTest?: string | null;
    regions?: string | null;
    userZipCode?: string | null;
    userCountryCode?: string | null;
    fetchRegionalInfo?: boolean | null;
    isClient: boolean;
    fetchSb: boolean;
    disableForceFacet?: boolean | null;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
};
export type sbRespRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"getDomainLinksSb_viewer" | "SbRespLayout_viewer" | "detectPageExistsAndRedirect_viewer">;
    };
};
export type sbRespRootQuery = {
    readonly response: sbRespRootQueryResponse;
    readonly variables: sbRespRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localeOrigin",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchTypes",
    "type": "[types]",
    "defaultValue": [
      "SEARCH"
    ]
  },
  {
    "kind": "LocalArgument",
    "name": "contentModuleId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "eligibleAbTest",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "regions",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": "0"
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchSb",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "disableForceFacet",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "contentModuleId",
    "variableName": "contentModuleId"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v8 = [
  (v4/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v15 = [
  (v12/*: any*/),
  (v11/*: any*/)
],
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v11/*: any*/)
      ]
    },
    (v11/*: any*/)
  ]
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentQuotes",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isComplimentary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v25/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v11/*: any*/)
          ]
        },
        (v11/*: any*/)
      ]
    },
    (v11/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variableAttributes",
  "storageKey": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variableAttributeData",
      "storageKey": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "swatchSort",
          "storageKey": null,
          "args": null,
          "concreteType": "SwatchSort",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "swatch",
              "storageKey": null,
              "args": null,
              "concreteType": "Swatch",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                (v4/*: any*/),
                (v29/*: any*/),
                (v11/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v11/*: any*/)
  ]
},
v31 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v32 = [
  (v31/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "searchAndBrowse"
  }
],
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v33/*: any*/)
  ]
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": (v32/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v34/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantityDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "textType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "amountType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v36 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": (v36/*: any*/),
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        (v37/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": (v36/*: any*/),
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphAttributeNames",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "period",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "origin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "style",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "periodPrefix",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v23/*: any*/)
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unit",
          "args": null,
          "storageKey": null
        },
        (v39/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": [
        (v39/*: any*/)
      ]
    }
  ]
},
v41 = {
  "kind": "LinkedField",
  "alias": "carouselPhotos",
  "name": "photos",
  "storageKey": "photos(limit:2)",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 2
    }
  ],
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "masterOrZoomPath",
      "args": null,
      "storageKey": null
    },
    (v11/*: any*/)
  ]
},
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "sellerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "SellerProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company",
      "args": null,
      "storageKey": null
    }
  ]
},
v43 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "showSeller",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v42/*: any*/)
      ]
    }
  ]
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkReference",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hexCode",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkable",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedFilterName",
  "args": null,
  "storageKey": null
},
v49 = [
  (v31/*: any*/)
],
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "photo",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtitle",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkText",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "Literal",
  "name": "first",
  "value": 12
},
v58 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "anchorText",
    "args": null,
    "storageKey": null
  },
  (v54/*: any*/),
  (v11/*: any*/)
],
v59 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
],
v60 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v61 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v62 = [
  {
    "kind": "Literal",
    "name": "address",
    "value": {
      "country": "us"
    }
  },
  {
    "kind": "Literal",
    "name": "regionBoundaryTypes",
    "value": [
      "METROPOLITAN",
      "DISTRICT",
      "DOMESTIC"
    ]
  },
  {
    "kind": "Literal",
    "name": "regionType",
    "value": "ITEM_LOCATION"
  }
],
v63 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v65 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "benefit",
    "args": null,
    "storageKey": null
  }
],
v66 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  (v57/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sbRespRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "getDomainLinksSb_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "SbRespLayout_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "detectPageExistsAndRedirect_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "sbRespRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "disableForceFacet",
                "variableName": "disableForceFacet"
              },
              {
                "kind": "Variable",
                "name": "eligibleAbTest",
                "variableName": "eligibleAbTest"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "localeOrigin",
                "variableName": "localeOrigin"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page"
              },
              {
                "kind": "Variable",
                "name": "regions",
                "variableName": "regions"
              },
              (v1/*: any*/)
            ],
            "concreteType": "ItemSearchQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "languageAnnotations",
                "storageKey": null,
                "args": null,
                "concreteType": "LanguageAnnotations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "available",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "href",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hrefLang",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "searchCorrections",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchCorrectionsType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "semanticSearchTerm",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "classificationLevel",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "classificationSearchTerm",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "appliedFilters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vanityUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "topCategoryL1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "browseContentModule",
                "storageKey": null,
                "args": (v6/*: any*/),
                "concreteType": null,
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moduleType",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "sort",
                "storageKey": null,
                "args": null,
                "concreteType": "SortType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentOption",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseSortCurrentOption",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryTiles",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseCategoryTiles",
                "plural": true,
                "selections": (v8/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "meta",
                "storageKey": null,
                "args": null,
                "concreteType": "MetaData",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canonical",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prev",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "disableIndexing",
                    "args": null,
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "next",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "microdata",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSearchQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": "photos(limit:1)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 1
                              }
                            ],
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "versions",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ItemPhotoVersion",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "webPath",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v11/*: any*/)
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageExists",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unauthorized",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "redirect",
                "storageKey": null,
                "args": null,
                "concreteType": "redirectType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchSb",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "searchCorrections",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "originalSearchTerm",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "forceSearchUri",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "suggestions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchCorrectionSuggestionsValues",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uri",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBeLocationSearch",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "meta",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subHeader",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "header",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canFollowSearch",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relatedSearchResults",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchResultConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSearchResultEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v30/*: any*/),
                                  (v35/*: any*/),
                                  (v38/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v43/*: any*/)
                                ]
                              },
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "appliedFilters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "plural": true,
                        "selections": [
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ]
                      },
                      (v48/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canBeDismissed",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "clearAllLinkReference",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAttributePage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "breadcrumbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseBreadcrumbs",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v22/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "priceTiles",
                    "storageKey": null,
                    "args": (v49/*: any*/),
                    "concreteType": "SearchBrowsePriceTile",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "browseContentModule",
                    "storageKey": null,
                    "args": (v6/*: any*/),
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleRegular",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleBanner",
                        "selections": [
                          (v50/*: any*/),
                          (v9/*: any*/),
                          (v51/*: any*/),
                          (v10/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModulePromo",
                        "selections": [
                          (v50/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pillText",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "headline",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtext",
                            "args": null,
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          (v53/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleIconicDesign",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "mainImage",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "categoryTiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "rank",
                        "args": null,
                        "storageKey": null
                      },
                      (v54/*: any*/),
                      (v55/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "masterImage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creatorDesignTiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CreatorDesignTiles",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v29/*: any*/),
                      (v23/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayMaxNumberOfPages",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bottomModule",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clearAppliedFiltersLinkReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "filters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v48/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v44/*: any*/),
                          (v47/*: any*/),
                          (v33/*: any*/),
                          (v46/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "stats",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "stats",
                            "plural": true,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "values",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v5/*: any*/),
                          (v45/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sort",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SortType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "options",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v44/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentOption",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "searchTerm",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v9/*: any*/),
                              (v56/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v17/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": "displayPriceTracking",
                                "name": "displayPrice",
                                "storageKey": null,
                                "args": (v32/*: any*/),
                                "concreteType": "ItemDisplayPriceType",
                                "plural": true,
                                "selections": [
                                  (v34/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v24/*: any*/),
                              (v27/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v23/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v35/*: any*/),
                              (v38/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v43/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "relatedItems",
                    "name": "thinBrowseRelatedItems",
                    "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                    "args": [
                      (v57/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "seller",
                        "value": "INCLUDE"
                      }
                    ],
                    "concreteType": "itemSearchMoreLikeThisConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "itemSearchMoreLikeThisEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v9/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v35/*: any*/),
                              (v38/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "showSeller",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v42/*: any*/),
                                      (v11/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "wpArticles",
                    "storageKey": "wpArticles(first:2)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                      }
                    ],
                    "concreteType": "WordpressArticleType",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "imageUrl",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WordpressArticleImageType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "thumb",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "medium",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "full",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v51/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "publishedDate",
                        "args": null,
                        "storageKey": null
                      },
                      (v52/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "source",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relatedPages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "plural": true,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "internalBuyLinks",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "plural": true,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "priceTiles",
                        "storageKey": null,
                        "args": (v49/*: any*/),
                        "concreteType": "SearchBrowsePriceTile",
                        "plural": true,
                        "selections": [
                          (v33/*: any*/),
                          (v55/*: any*/),
                          (v54/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "facets",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFacets",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "location",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FacetValueType",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "label",
                                "args": null,
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isBillboardAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isThinItemSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isContentModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "BROWSE_CONTENT_MODULES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isWordpressArticlesEnabled",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "wordpressArticles"
              }
            ],
            "storageKey": "featureFlag(feature:\"wordpressArticles\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isShopByRoomEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SHOP_BY_ROOM"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbRespFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableFollowSearchStickyBanner",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableFollowSearchStickyBanner"
              }
            ],
            "storageKey": "isEnabled(key:\"disableFollowSearchStickyBanner\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabledByLocale",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSkyscraperAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMatchedSetsEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableMatchedSetsFacet"
              }
            ],
            "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFINE_MENU_SEARCH"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isDeliveryOptionsDisabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTileAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": (v59/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTradeDoubleClickAdsOnSbDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableTradeDoubleClickAdsOnSB"
              }
            ],
            "storageKey": "isEnabled(key:\"disableTradeDoubleClickAdsOnSB\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "phoneNumbers",
                "storageKey": null,
                "args": null,
                "concreteType": "support",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tradeSupport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "formatType",
                        "value": "INTERNATIONAL"
                      }
                    ],
                    "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "showCreatorDesignTiles",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "sbCreatorDesignTiles"
              }
            ],
            "storageKey": "featureFlag(feature:\"sbCreatorDesignTiles\")"
          },
          (v11/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  (v60/*: any*/),
                  (v61/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regionsByZipCode",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  },
                  (v11/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isSbTradeFreeShippingTestDisabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableSbTradeFreeShippingTest"
                  }
                ],
                "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regions",
                "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                "args": (v62/*: any*/),
                "concreteType": "Region",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingFilters",
                    "storageKey": null,
                    "args": [
                      (v60/*: any*/),
                      (v1/*: any*/),
                      (v61/*: any*/)
                    ],
                    "concreteType": "ShippingFilterType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regions",
                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                    "args": (v62/*: any*/),
                    "concreteType": "Region",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "regionBoundary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "type",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RegionBoundaryType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "locations",
                "name": "itemFacetSearch",
                "storageKey": null,
                "args": [
                  (v60/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "facetLimit",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "facetName",
                    "value": "location"
                  },
                  (v1/*: any*/),
                  (v61/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v44/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v63/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favorites",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      },
                      {
                        "kind": "Variable",
                        "name": "pages",
                        "variableName": "followSearchPages"
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "followSearchTypes"
                      }
                    ],
                    "concreteType": "favoritesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canShowInternalSellerName",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_SELLER_NAME"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "showStrategicPartnerFilter",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "STRATEGIC_PARTNER_FILTERING"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verifiedTradeStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v64/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v63/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v64/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "educationMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v65/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pointsToMaintainStatus",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pointsMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v65/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "homepageMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v65/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "postCheckoutMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v65/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tpnRole",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmTPNRole",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v66/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstPhotoWebPath",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdpURL",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v12/*: any*/),
                                  (v56/*: any*/),
                                  (v16/*: any*/),
                                  (v11/*: any*/),
                                  (v7/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v66/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "sbRespRootQuery",
    "id": "app-buyer-finding/270.0.0-2020-06-25T07:52:06.346Z/sbRespRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '8bb366c6fdc08fe24e01ee86485195e0';
export default node;
